"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remapPageStructureIds = remapPageStructureIds;
const page_document_maps_1 = require("./page-document-maps");
const page_structure_entry_1 = require("./page-structure-entry");
const page_structure_tree_1 = require("./page-structure-tree");
const page_structure_writer_1 = require("./page-structure-writer");
/** Remaps structural identities, retaining ordering, presentation and sentinels. */
function remapPageStructureIds(doc, idMap, partId = page_document_maps_1.PAGE_DOCUMENT_PART_ID) {
    const structure = (0, page_document_maps_1.pageStructureMap)(doc);
    const entries = (0, page_structure_writer_1.readPageStructureEntries)(structure, partId);
    const reference = (id) => id === page_structure_tree_1.PAGE_TREE_DELETED_ID || id === page_structure_tree_1.PAGE_TREE_RECOVERED_ID
        ? id
        : (idMap.get(id) ?? id);
    doc.transact(() => {
        // Snapshot first: target IDs may also be source IDs.
        for (const id of entries.keys())
            structure.delete(id);
        for (const [id, entry] of entries)
            structure.set(idMap.get(id) ?? id, (0, page_structure_entry_1.encodePageStructureEntry)({
                ...entry,
                p: entry.p === null ? null : reference(entry.p),
                ...(entry.g === undefined ? {} : { g: reference(entry.g) }),
                ...(entry.c === undefined
                    ? {}
                    : {
                        c: [
                            entry.c[0] === null ? null : reference(entry.c[0]),
                            entry.c[1] === null ? null : reference(entry.c[1]),
                        ],
                    }),
            }));
    });
}
